import { Link } from 'react-router-dom';
import SeoHead from '../components/SeoHead';
import GalleryLightbox from '../components/GalleryLightbox';
import { imageUrl } from '../lib/images';

export default function GlasfiberContainerePage() {
  const databladPdf = 'https://assets.auxodev.dk/assets/9692fb57-52ae-41f1-9d47-5179b8f3a973/joca-produktblad-4-hjulet-glasfiber.pdf';
  const vedligeholdPdf = 'https://assets.auxodev.dk/assets/9692fb57-52ae-41f1-9d47-5179b8f3a973/vedligehold-overflader.pdf';
  const produkterVedligeholdPdf = 'https://assets.auxodev.dk/assets/9692fb57-52ae-41f1-9d47-5179b8f3a973/produkter-til-vedligeholdelse.pdf';

  return (
    <>
      <SeoHead
        title="Glasfiber containere - RB Glasfiber A/S"
        description="Download datablad. 300 - 400 - 600 - 800 - 1000 liter. En stærk dansk håndoplagt glasfibercontainer fremstillet efter danske mål, tilpasset samtlige komprimatorbiler. Let håndtering."
        canonical="https://www.rb-glasfiber.dk/produkter/glasfiber-containere"
        ogImage="https://assets.auxodev.dk/assets/9692fb57-52ae-41f1-9d47-5179b8f3a973/joca-4-hjulet-affaldsbeholder-glasfiber-container2-cropresize-625x625.webp"
      />

      {/* Hero Header */}
      <section className="relative pt-32 pb-16 lg:pt-40 lg:pb-24 bg-slate-950 text-white overflow-hidden border-b border-slate-800">
        <div className="absolute inset-0 z-0">
          <img
            src={imageUrl('https://assets.auxodev.dk/assets/9692fb57-52ae-41f1-9d47-5179b8f3a973/joca-4-hjulet-affaldsbeholder-glasfiber-container2-cropresize-625x625.webp', 'width=1600,quality=80,format=auto')}
            alt="Glasfiber containere"
            className="w-full h-full object-cover opacity-20"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-slate-950 via-slate-950/80 to-slate-950/60" />
        </div>

        <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="max-w-3xl">
            <div className="inline-flex items-center gap-2 px-3 py-1 rounded bg-[#1e9457]/20 border border-[#1e9457]/40 text-[#22c55e] text-xs font-bold uppercase tracking-widest mb-4">
              <i className="fa-solid fa-dumpster"></i>
              <span>Affaldscontainere</span>
            </div>
            <h1 className="text-3xl sm:text-5xl font-extrabold uppercase tracking-tight text-white mb-4">
              Glasfiber containere
            </h1>
            <p className="text-xl text-[#22c55e] font-semibold mb-6">
              300 - 400 - 600 - 800 - 1000 liter
            </p>
            <p className="text-base sm:text-lg text-slate-300 leading-relaxed max-w-2xl">
              En stærk dansk håndoplagt glasfibercontainer fremstillet efter danske mål, tilpasset samtlige komprimatorbiler.
            </p>

            <div className="mt-8 flex flex-wrap items-center gap-4">
              <a
                href={databladPdf}
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center gap-2.5 px-6 py-3.5 rounded bg-[#1e9457] hover:bg-[#15703f] text-white font-bold uppercase tracking-wider text-sm shadow transition-all"
              >
                <i className="fa-solid fa-file-pdf"></i>
                <span>Download datablad (PDF)</span>
              </a>
              <Link
                to="/kontakt"
                className="inline-flex items-center gap-2 px-6 py-3.5 rounded bg-slate-800 hover:bg-slate-700 text-white font-semibold text-sm border border-slate-700 transition-all"
              >
                <span>Indhent tilbud</span>
                <i className="fa-solid fa-arrow-right text-xs"></i>
              </Link>
            </div>
          </div>
        </div>
      </section>

      {/* Main Content */}
      <section className="py-16 bg-white border-b border-slate-200">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 space-y-16">
          <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 items-center">
            <div className="lg:col-span-7 space-y-6">
              <div>
                <h2 className="text-2xl sm:text-3xl font-extrabold text-slate-900 uppercase">
                  Let håndtering & robust konstruktion
                </h2>
                <div className="w-12 h-1 bg-[#1e9457] mt-3"></div>
              </div>

              <div className="space-y-4 text-slate-700 leading-relaxed text-base">
                <div>
                  <h3 className="font-bold text-slate-900 uppercase text-sm mb-1">Let håndtering</h3>
                  <p>
                    Som standard leveres minicontaineren med 200 mm. letløbende hjul. Andre størrelser kan naturligvis leveres. Derudover kan containeren forsynes med 5 forskellige typer af sidehåndtag. Containeren kan leveres med hjulkasse, hvor lavere højde er påkrævet.
                  </p>
                </div>

                <div>
                  <h3 className="font-bold text-slate-900 uppercase text-sm mb-1">Anvendelse</h3>
                  <p>
                    Minicontaineren kan anvendes til indsamling af alle fraktionstyper, ligesom den kan forsynes med indkast til flasker eller papir. Glatte indvendige sider hindrer fastklæbning af affaldet.
                  </p>
                </div>

                <div>
                  <h3 className="font-bold text-slate-900 uppercase text-sm mb-1">Robust konstruktion</h3>
                  <p>
                    Minicontaineren er håndoplagt med korrekt blandingsforhold i måtter, polyester, gelcoat og farvepasta, ligesom den naturligvis er forstærket på alle slidflader herunder på bunden, hjørner og kanter. Låget fremstilles med forstærkning.
                  </p>
                </div>
              </div>

              {/* Teknisk data punktliste */}
              <div className="p-6 rounded-lg bg-slate-50 border border-slate-200">
                <h3 className="font-bold text-slate-900 uppercase text-sm mb-3">Teknisk data</h3>
                <ul className="grid grid-cols-1 sm:grid-cols-2 gap-2 text-sm text-slate-700">
                  <li className="flex items-center gap-2">
                    <i className="fa-solid fa-check text-[#1e9457]"></i>
                    <span>Alt jern i galvaniseret stål</span>
                  </li>
                  <li className="flex items-center gap-2">
                    <i className="fa-solid fa-check text-[#1e9457]"></i>
                    <span>Farve efter ønske</span>
                  </li>
                  <li className="flex items-center gap-2">
                    <i className="fa-solid fa-check text-[#1e9457]"></i>
                    <span>Mulighed for påmaling af navn/logo mv.</span>
                  </li>
                  <li className="flex items-center gap-2">
                    <i className="fa-solid fa-check text-[#1e9457]"></i>
                    <span>Leveres bl.a. med flaske- eller papirindkast</span>
                  </li>
                  <li className="flex items-center gap-2">
                    <i className="fa-solid fa-check text-[#1e9457]"></i>
                    <span>Forstærket på alle udsatte steder</span>
                  </li>
                  <li className="flex items-center gap-2">
                    <i className="fa-solid fa-check text-[#1e9457]"></i>
                    <span>Størrelser: 300 l, 400 l, 600 l, 800 l, 1000 l</span>
                  </li>
                </ul>
              </div>
            </div>

            <div className="lg:col-span-5 space-y-4">
              <div className="rounded-xl overflow-hidden border border-slate-200 shadow-md aspect-square bg-slate-900">
                <img
                  src={imageUrl('https://assets.auxodev.dk/assets/9692fb57-52ae-41f1-9d47-5179b8f3a973/joca-4-hjulet-affaldsbeholder-glasfiber-container2-cropresize-625x625.webp', 'width=700,quality=85,format=auto')}
                  alt="4-hjulet glasfibercontainer"
                  className="w-full h-full object-cover"
                />
              </div>

              {/* Maintenance Guides Download */}
              <div className="p-4 bg-slate-100 rounded-lg text-sm space-y-2 border border-slate-200">
                <div className="font-bold text-slate-900 text-xs uppercase tracking-wide">
                  Vedligehold af gel-coat overflade:
                </div>
                <div className="flex flex-col gap-1.5 text-xs">
                  <a
                    href={vedligeholdPdf}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-[#1e9457] hover:underline inline-flex items-center gap-1.5"
                  >
                    <i className="fa-solid fa-file-pdf"></i>
                    <span>Vejledning: Vedligehold overflader (PDF)</span>
                  </a>
                  <a
                    href={produkterVedligeholdPdf}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-[#1e9457] hover:underline inline-flex items-center gap-1.5"
                  >
                    <i className="fa-solid fa-file-pdf"></i>
                    <span>Vejledning: Produkter til vedligeholdelse (PDF)</span>
                  </a>
                </div>
              </div>
            </div>
          </div>

          {/* Dimension Tables from Scraped Document */}
          <div className="space-y-6 pt-6 border-t border-slate-200">
            <h3 className="text-2xl font-bold uppercase tracking-tight text-slate-900">
              Mål og dimensioner
            </h3>

            <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
              {/* Table 1: Med hjulkasse */}
              <div className="border border-slate-200 rounded-lg overflow-hidden">
                <div className="bg-slate-900 text-white px-4 py-3 font-bold text-sm uppercase tracking-wide">
                  Dimensioner med hjulkasse
                </div>
                <div className="overflow-x-auto">
                  <table className="w-full text-left text-sm text-slate-700">
                    <thead className="bg-slate-100 text-slate-900 font-bold border-b border-slate-200 text-xs uppercase">
                      <tr>
                        <th className="px-4 py-2.5">Størrelse</th>
                        <th className="px-4 py-2.5">Bredde</th>
                        <th className="px-4 py-2.5">Dybde</th>
                        <th className="px-4 py-2.5">Højde</th>
                      </tr>
                    </thead>
                    <tbody className="divide-y divide-slate-100 font-mono text-xs">
                      <tr><td className="px-4 py-2.5 font-bold font-sans">400 liter</td><td className="px-4 py-2.5">915 mm</td><td className="px-4 py-2.5">720 mm</td><td className="px-4 py-2.5">1160 mm</td></tr>
                      <tr className="bg-slate-50/50"><td className="px-4 py-2.5 font-bold font-sans">600 liter</td><td className="px-4 py-2.5">1145 mm</td><td className="px-4 py-2.5">810 mm</td><td className="px-4 py-2.5">1130 mm</td></tr>
                      <tr><td className="px-4 py-2.5 font-bold font-sans">800 liter</td><td className="px-4 py-2.5">1290 mm</td><td className="px-4 py-2.5">810 mm</td><td className="px-4 py-2.5">1160 mm</td></tr>
                      <tr className="bg-slate-50/50"><td className="px-4 py-2.5 font-bold font-sans">1000 liter</td><td className="px-4 py-2.5">1585 mm</td><td className="px-4 py-2.5">810 mm</td><td className="px-4 py-2.5">1170 mm</td></tr>
                      <tr><td className="px-4 py-2.5 font-bold font-sans">1400 liter</td><td className="px-4 py-2.5">1750 mm</td><td className="px-4 py-2.5">950 mm</td><td className="px-4 py-2.5">1220 mm</td></tr>
                    </tbody>
                  </table>
                </div>
              </div>

              {/* Table 2: Med flad bund */}
              <div className="border border-slate-200 rounded-lg overflow-hidden">
                <div className="bg-slate-900 text-white px-4 py-3 font-bold text-sm uppercase tracking-wide">
                  Dimensioner med flad bund
                </div>
                <div className="overflow-x-auto">
                  <table className="w-full text-left text-sm text-slate-700">
                    <thead className="bg-slate-100 text-slate-900 font-bold border-b border-slate-200 text-xs uppercase">
                      <tr>
                        <th className="px-4 py-2.5">Størrelse</th>
                        <th className="px-4 py-2.5">Bredde</th>
                        <th className="px-4 py-2.5">Dybde</th>
                        <th className="px-4 py-2.5">Højde</th>
                      </tr>
                    </thead>
                    <tbody className="divide-y divide-slate-100 font-mono text-xs">
                      <tr><td className="px-4 py-2.5 font-bold font-sans">300 liter</td><td className="px-4 py-2.5">700 mm</td><td className="px-4 py-2.5">620 mm</td><td className="px-4 py-2.5">1200 mm</td></tr>
                      <tr className="bg-slate-50/50"><td className="px-4 py-2.5 font-bold font-sans">400 liter</td><td className="px-4 py-2.5">915 mm</td><td className="px-4 py-2.5">720 mm</td><td className="px-4 py-2.5">1210 mm</td></tr>
                      <tr><td className="px-4 py-2.5 font-bold font-sans">600 liter</td><td className="px-4 py-2.5">1145 mm</td><td className="px-4 py-2.5">810 mm</td><td className="px-4 py-2.5">1200 mm</td></tr>
                      <tr className="bg-slate-50/50"><td className="px-4 py-2.5 font-bold font-sans">800 liter</td><td className="px-4 py-2.5">1290 mm</td><td className="px-4 py-2.5">810 mm</td><td className="px-4 py-2.5">1250 mm</td></tr>
                      <tr><td className="px-4 py-2.5 font-bold font-sans">1000 liter</td><td className="px-4 py-2.5">1585 mm</td><td className="px-4 py-2.5">810 mm</td><td className="px-4 py-2.5">1250 mm</td></tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>

          {/* Lightbox Gallery */}
          <div className="pt-8 border-t border-slate-200">
            <GalleryLightbox
              gallerySlug="standardprodukter"
              title="Fotogalleri: Glasfiber containere"
              description="Se billeder af vores håndoplagte minicontainere i praksis."
              columns={3}
            />
          </div>
        </div>
      </section>
    </>
  );
}
